import { gql } from '@apollo/client';

export const CREATE_GIFT_CARD_ACTIVATION_SESSION = gql(`
  mutation CreateGiftCardActivationSession($code: String!) {
    createGiftCardActivationSession(code: $code) {
      activationSessionToken
      giftCardId
      expiresAt
    }
  }
`);

export const UPDATE_GIFT_CARD_ACTIVATION_DETAILS_SELF = gql(`
  mutation UpdateGiftCardActivationDetailsSelf(
    $activationSessionToken: String!
    $activateForSelf: GiftCardActivateForSelfDetailsInput!
  ) {
    updateGiftCardActivationDetails(
      activationSessionToken: $activationSessionToken
      flow: ACTIVATE_FOR_SELF
      activateForSelf: $activateForSelf
    ) {
      success
      accountPreview {
        userId
        displayName
        profileImage
        phoneMasked
      }
    }
  }
`);

export const UPDATE_GIFT_CARD_ACTIVATION_DETAILS_GIFT = gql(`
  mutation UpdateGiftCardActivationDetailsPayAndGift(
    $activationSessionToken: String!
    $payAndGift: GiftCardPayAndGiftDetailsInput!
  ) {
    updateGiftCardActivationDetails(
      activationSessionToken: $activationSessionToken
      flow: PAY_AND_GIFT
      payAndGift: $payAndGift
    ) {
      success
      accountPreview {
        userId
        displayName
        profileImage
        phoneMasked
      }
    }
  }
`);

export const CREATE_GIFT_CARD_ACTIVATION_PAYMENT_INTENT = gql(`
  mutation CreateGiftCardActivationPaymentIntent(
    $activationSessionToken: String!
    $promotionCode: String
  ) {
    createGiftCardActivationPaymentIntent(
      activationSessionToken: $activationSessionToken
      promotionCode: $promotionCode
    ) {
      paymentIntentSecret
      giftCardId
      discount {
        promotionCode
        percentOff
        originalAmount
        discountAmount
        finalAmount
      }
    }
  }
`);

export const COMPLETE_GIFT_CARD_ACTIVATION = gql(`
  mutation CompleteGiftCardActivationAfterPayment($paymentIntentId: String!) {
    completeGiftCardActivationAfterPayment(paymentIntentId: $paymentIntentId) {
      status
      message
    }
  }
`);

export const REDEEM_GIFT_CARD = gql(`
  mutation RedeemGiftCard($code: String!) {
    redeemGiftCard(code: $code) {
      balanceAfter
      programName
      sessionCount
      packageName
    }
  }
`);
